export default __webpack_public_path__ + "static/media/pdf.a832058b.svg";